import React from 'react';
import PropTypes from 'prop-types';
import './SignInButton.css';
import AppConfig from "../../AppConfig";
import {useGoogleLogin} from "@react-oauth/google";
import GoogleIcon from "../../assets/custom-icons/GoogleIcon";

const TSignInButton = {
    // English
    "enUS": {
        'SIGN_IN': 'Sign in with Google',
    },
    // Spanish
    "esMX": {
        'SIGN_IN': 'Acceder con Google',
    }
}

const GoogleSignIn = ({ onClick }) => {
    const login = useGoogleLogin({
        onSuccess: tokenResponse => {
            console.log(tokenResponse)
            onClick(tokenResponse)
        }
    });

    return (
        <button
            className="sign-in-button"
            onClick={() => {
                login()
            }}
        >
            <GoogleIcon style={{ marginRight: 5 }} />
            {TSignInButton[AppConfig.lang].SIGN_IN}
        </button>
    );
};

GoogleSignIn.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default GoogleSignIn;
